export default "__VITE_ASSET__c0fe5c93__"